
import React, { Component, createContext, useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import Select from 'components/form/Select'

export default class SelectCreatable extends Component {
  static Context = createContext({ options: null, createOption: null })

  static Provider = ({ createOption, options: defaultOptions, children }) => {
    const [options, setOptions] = useState(defaultOptions)

    return <SelectCreatable.Context.Provider value={{ options, createOption }}>
      {children}
    </SelectCreatable.Context.Provider>
  }

  Content = () => {
    const { value, ...props } = this.props
    const { options, createOption } = useContext(SelectCreatable.Context)

    useEffect(() => {
      if (value && !options.find(item => item.value === value))
        createOption && options.push(createOption(value))
    }, [value])


    return <Select {...props} creatable
      value={value}
      newOptionCreator={createOption && (({ label }) => createOption(label))}
      options={options}
    />
  }

  render() {
    return <this.Content />
  }
}

SelectCreatable.Provider.defaultProps = {
  createOption: label => ({ label, value: label }),
  options: [],
}